// extracted by mini-css-extract-plugin
export default {"content":"software-details-page_content__ewzrG","informationColumn":"software-details-page_informationColumn__8b1mH","tablesColumn":"software-details-page_tablesColumn__odDTY"};